import React, { useState, useLayoutEffect, useContext } from 'react';
import { MdDelete } from 'react-icons/md';

import * as S from './styles';
import Modal from 'components/Modal';
import { Link, ItemDataRedirect } from 'types/InputVerticalRedirectLinkProps';
import SimpleInput from 'components/SimpleInput';
import { generateUid } from 'utils/functions';
import AddBtn from 'components/AddBtn';
import SystemNotifyContext from 'context/SystemNotifyContext';

interface FormAddDataRedirectVerticalRedirectableLinkProps {
	link: Link;
	isOpen: boolean;
	functionToGetDataAboutDataRedirect: any;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function FormAddDataRedirectVerticalRedirectableLink({
	setIsOpen,
	isOpen,
	link,
	functionToGetDataAboutDataRedirect
}: FormAddDataRedirectVerticalRedirectableLinkProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const [datas, setDatas] = useState<ItemDataRedirect[]>([
		{ idFront: generateUid(), key: '', value: '' }
	]);
	const [canSave, setCanSave] = useState(false);

	function handleCancel() {
		setIsOpen(false);
	}

	function handleSave() {
		if (canSave) {
			setIsOpen(false);
			functionToGetDataAboutDataRedirect(datas);
		} else {
			handleNotify('Preencha todos os campos "Key" e "Value"', 'error');
		}
	}

	function verifyIfCanSave() {
		setCanSave(true);
		datas.forEach((item) => {
			if (item.key === '' || item.value === '') {
				setCanSave(false);
			}
		});
	}

	function deleteDateFromArray(id: string) {
		const newArray = datas.filter((date) => date.idFront !== id);
		setDatas(newArray);
	}

	useLayoutEffect(() => {
		if (link.data_redirect.length > 0) {
			setTimeout(() => {
				setDatas(link.data_redirect);
			}, 100);
		}
	}, []);

	useLayoutEffect(() => {
		verifyIfCanSave();
	}, [datas]);

	return (
		<Modal
			isOpenProps={isOpen}
			setIsOpenModal={() => {
				setIsOpen((value) => !value);
			}}
			title={'Dado de redirecionamento'}
			buttonClose={false}
		>
			<S.container>
				<AddBtn
					text="Adicionar link"
					anyFunction={() =>
						setDatas((obj) => [
							...obj,
							{ idFront: generateUid(), key: '', value: '' }
						])
					}
				/>

				<S.datasBox>
					{datas.map((item, i) => (
						<S.itemList key={item.idFront}>
							<SimpleInput
								label="Key *"
								initialValue={item.key}
								getValue={(value: string) => {
									setDatas((allDates) => {
										allDates[i].key = value;
										return [...allDates];
									});
								}}
							/>

							<SimpleInput
								label="Value *"
								initialValue={item.value}
								getValue={(value: string) => {
									setDatas((allDates) => {
										allDates[i].value = value;
										return [...allDates];
									});
								}}
							/>

							<MdDelete onClick={() => deleteDateFromArray(item.idFront)} />
						</S.itemList>
					))}

					{datas.length === 0 && (
						<S.centralize>
							<p>Não dados</p>
						</S.centralize>
					)}
				</S.datasBox>

				<S.containerBtns>
					<S.cancel onClick={handleCancel}>Cancelar</S.cancel>

					<S.save onClick={handleSave}>Salvar</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
